















import PageBody from "@/components/PageBody.vue";
import PageHeader from "@/components/PageHeader.vue";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
	components: {
		"page-header": PageHeader,
		"page-body": PageBody,
	},
})
export default class AccountView extends Vue {
	mounted() {
		if (this.$route.path == "/account") {
			this.$router.push("/account/general");
		}
	}

	@Watch("$route.path")
	pathChanged(): void {
		if (this.$route.path == "/account") {
			this.$router.push("/account/general");
		}
	}
}
